import AuthGuard from "../../guards/AuthGuard";
import { useSelector } from "react-redux";
import { RootState } from "../../redux/store";
import IndividualKycForm from "./IndividualKycForm";
import BusinessKycForm from "./BusinessKycForm";
import { ProgressSpinner } from "primereact/progressspinner";
import Loader from '../../components/common/Loader';
import { Navigate } from "react-router-dom";

type Props = {};

const KycPage = (props: Props) => {
  const { currentUser, loading } = useSelector(
    (state: RootState) => state.auth
  );

  return (
    <AuthGuard>
      {loading ? (
        <div className="loader-container absolute inset-0 flex justify-center items-center bg-white opacity-50 z-50">
          <ProgressSpinner style={{ width: "50px", height: "50px" }} />
        </div>
      ) : currentUser ? (
        currentUser.role.role_code !== "CUSTOMER" && currentUser.role.role_code !== "ENTERPRISE" ? (
          <Navigate to="/admin" replace />

        ) : currentUser.customer ? (
          currentUser.customer.isEntreprise ? (
            <BusinessKycForm />
          ) : (
            <IndividualKycForm />
          )
        ) : (
          <div className="flex justify-center items-center h-screen text-xl text-gray-500">
            <Loader />
          </div>
        )
      ) : (
        <div className="flex justify-center items-center h-screen text-xl text-gray-500">
          <Loader />
        </div>
      )
      }
    </AuthGuard>
  );
};

export default KycPage;